import React, { useState, useEffect, useCallback } from "react";
import SearchBar from "./SearchBar";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import ButtonBar from "../../../components/Layout/ButtonBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import useAuiGridMethods from "../../../hooks/AuiGrid/useAuiGridMethods";
import {
  createAuthColumnData,
  createGroupColumnData,
  createAuthGroupColumnData,
} from "./conlumnLayout";

import { useId } from "react-id-generator";
import { saveGridCheckData } from "../../../utils/validators";

const AuthGroupMng = (props) => {
  const [authGrid] = useId(1, "aui-grid-");
  const [authGroupGrid] = useId(1, "aui-grid-");
  const [groupGrid] = useId(1, "aui-grid-");

  let auiAuthGrid = useAuiGridMethods(authGrid);
  let auiAuthGroupGrid = useAuiGridMethods(authGroupGrid);
  let auiGroupGrid = useAuiGridMethods(groupGrid);

  //그리드 초기 설정
  useEffect(() => {
    auiAuthGrid.create(createAuthColumnData(), {
      ...defaultGridProps,
    });
    auiAuthGroupGrid.create(createAuthGroupColumnData(), {
      ...defaultGridProps,
    });
    auiGroupGrid.create(createGroupColumnData(), {
      ...defaultGridProps,
    });

    auiAuthGrid.bind("cellClick", function (event) {
      searchAuthMenuList(event.item.authId);
    });

    handleGroupSearch();
  }, []);

  const [primaryParameters, setPrimaryParameters] = useState({
    schAuthId: "",
    schAuthNm: "",
  });
  //권한정보 검색 URL
  const SERARCH_AUTH_URL = "/common/auth/searchAuthList.do";
  //권한별메뉴정보 검색 URL
  const SERARCH_AUTH_GROUP_URL = "/common/auth/searchAuthGroupList.do";
  //권한별메뉴정보 저장 URL
  const SAVE_AUTH_GROUP_URL = "/common/auth/saveAuthGroupList.do";
  //권한별메뉴정보 삭제 URL
  const DELETE_AUTH_GROUP_URL = "/common/auth/deleteAuthGroupList.do";
  //메뉴정보 검색 URL
  const SERARCH_GROUP_URL = "/common/group/searchGroupList.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_AUTH_URL,
    },
    { manual: true }
  );

  const [groupFieldValues, setGroupFieldValues] = useState({
    schGroupId: "",
    schGroupNm: "",
  });

  const handleGroupSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_GROUP_URL,
      params: groupFieldValues,
    });

    auiGroupGrid.setGridData(data);
  };

  const handleMasterSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_AUTH_URL,
      params: primaryParameters,
    });
    auiAuthGrid.setGridData(data);
  };

  const searchAuthMenuList = async (authId) => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_AUTH_GROUP_URL,
      params: { schAuthId: authId },
    });

    auiAuthGroupGrid.setGridData(data);
  };

  const handleMasterDelete = async () => {
    auiAuthGroupGrid.removeRow("selectedIndex");
  };
  const handleMasterSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      const addItems = auiAuthGroupGrid.getAddedRowItems();
      const editItems = auiAuthGroupGrid.getEditedRowItems();
      const removeItems = auiAuthGroupGrid.getRemovedItems();

      let param = saveGridCheckData(addItems, editItems, removeItems);

      const {
        data: { data },
      } = await fetchData({
        url: SAVE_AUTH_GROUP_URL,
        data: param,
        method: "POST",
      });

      const authItem = auiAuthGrid.getSelectedItems()[0].item;

      searchAuthMenuList(authItem.authId);
    }
  };

  //권한별메뉴 그리드에 검색한 메뉴 추가
  const handleGroupAuthAdd = () => {
    const groupItem = auiGroupGrid.getSelectedItems()[0].item;
    //console.log(groupItem);
    const authItem = auiAuthGrid.getSelectedItems()[0].item;
    //console.log(authItem);

    var rows = auiAuthGroupGrid.getRowsByValue("groupId", groupItem.groupId);
    //console.log(rows);
    if (rows.length > 0) {
      ModalConfirm({
        title: "그룹존재",
        description:
          "선택한 그룹은 그리드에 있습니다. 다시 선택하시기 바랍니다. ",
        type: "alert",
      });
    } else {
      groupItem.authId = authItem.authId;
      auiAuthGroupGrid.addRow(groupItem, "last");
    }
  };

  //메뉴검색 항목이 변경될때 사용되는 함수
  const handleGroupChangeField = useCallback((event) => {
    const { name, value } = event.target;

    setGroupFieldValues({ ...groupFieldValues, [name]: value });
  });

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterDelete={handleMasterDelete}
        handleMasterSave={handleMasterSave}
      />
      <SearchBar setSearchParameters={setPrimaryParameters} />

      <div className="flexible_contents_box2">
        <div className="databox" style={{ width: "100%", height: "100%" }}>
          <div className="scrollbox">
            <div style={{ width: "100%", height: "100%" }}>
              <div id={authGrid} style={{ width: "100%", height: 600 }} />
            </div>
          </div>
        </div>
        <div className="databox">
          <div className="subdatabox">
            <div id={authGroupGrid} style={{ height: 300 }} />
            <div className="searchdata">
              <ul className="displays">
                <li style={{ width: "180px" }}>
                  <div style={{ width: "80px" }}>
                    <font color="grey">⦁</font> 그룹아이디
                  </div>
                  <input
                    type="text"
                    className="datainput"
                    name="schGroupId"
                    style={{ width: "100px" }}
                    onChange={handleGroupChangeField}
                  />
                </li>
                <li style={{ width: "150px" }}>
                  <div style={{ width: "80px" }}>
                    <font color="grey">⦁</font> 그룹명
                  </div>
                  <input
                    type="text"
                    className="datainput"
                    name="schGroupNm"
                    style={{ width: "100px" }}
                    onChange={handleGroupChangeField}
                  />
                </li>
                <li style={{ width: "150px" }}>
                  <button
                    type="button"
                    className="btn_orenge updown0"
                    onClick={handleGroupSearch}
                  >
                    검색
                  </button>
                  <button
                    type="button"
                    className="btn_orenge updown0"
                    onClick={handleGroupAuthAdd}
                  >
                    추가
                  </button>
                </li>
              </ul>
            </div>
            <div id={groupGrid} style={{ height: 250 }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthGroupMng;
